import React from 'react';

export default class BenTrongNgoaiSelect extends React.Component {
  static propTypes = {};

  state={}
  
  componentDidMount() {
    
  }
  

  render() {
    return (
      <div className="bp3-non-ideal-state" style={{height: '50vh'}}>
      <div className="bp3-non-ideal-state-visual" style={{fontSize: 150}}>
        <span className="bp3-icon bp3-icon-build"></span>
      </div>
      <h1 className="bp3-heading" style={{maxWidth: 700}}>Trang đang được xây dựng</h1>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pageBuilding/index.js